module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAASCAYAAABIB77kAAAAY0lEQVQ4jWP8+v3nfwY6AiZ6WkaShWHxRfS18PWb9/S1kFpg1EKqA0b0fAhKjaQkEGEhfobVi/oZGBkZybMQF3D0TmTYv3U+0Q7BBYZ/HI5aCAeiIoJUsZDoVEotMHiDlFoAAFZIHNg6urzzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xjtb1-1.png
// module id = 725
// module chunks = 0